<template>
    <Article>
        <template #header>
            <h2>Congressional Gold Medal Campaign</h2>
        </template>
        <template #content>
            <div id="post-1244" class="clearfix post-1244 page type-page status-publish hentry">
                <div class="site-content">
                    <div id="content" class="site-content">
                        <article class="clearfix post-1093 page type-page status-publish hentry">
                            <div dir="ltr" style="text-align:center">
                                <h6 style="text-align:left">
                                    Update about Congressional Gold Medal process and events, posted
                                    04/27/2022
                                </h6>
                                <p style="text-align:left">
                                    The CGM bill has passed, the medal is being designed, and it can
                                    take months to complete the design process.
                                </p>
                                <p style="text-align: left">
                                    The award ceremony is going to be a virtual ceremony. The
                                    ceremony will be aired the week before Memorial Day on CSPAN.
                                    Details on time, date, and how you can watch will be posted on
                                    our website and Facebook group as soon as they become available.
                                </p>
                            </div>
                        </article>
                    </div>
                </div>
                <p>&nbsp;</p>
                <div class="site-content">
                    <div id="content" class="site-content">
                        <article class="clearfix post-1093 page type-page status-publish hentry">
                            <div>
                                <div dir="ltr" style="text-align:center">
                                    <h6 style="text-align:left">
                                        Update: Congressional Gold Medal signed into law! 10/17/2020
                                    </h6>
                                    <p>
                                        <img
                                            loading="lazy"
                                            class="size-full wp-image-1499 aligncenter"
                                            src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauderscgmsigned-1.png?alt=media"
                                            alt=""
                                            width="594"
                                            height="721"
                                            srcset="
                                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauderscgmsigned-1.png?alt=media 594w,
                                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauderscgmsigned-1.png?alt=media 247w,
                                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauderscgmsigned-1.png?alt=media 330w,
                                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauderscgmsigned-1.png?alt=media 165w
                                            "
                                            sizes="(max-width: 594px) 100vw, 594px"
                                        />
                                    </p>

                                    <p style="font-weight:400">
                                        A huge&nbsp;
                                        <strong>THANK YOU</strong>
                                        &nbsp;to everyone — and that's pretty much all of you — who
                                        have helped make this a reality.
                                    </p>
                                    <p style="font-weight:400">
                                        A very special&nbsp;
                                        <strong>"THANK&nbsp;YOU"</strong>
                                        &nbsp;to Merrill's Marauders Bob Passanisi, 96, from New
                                        York and Gilbert Howland, 97, from New Jersey who have
                                        represented the 5307th Composite Unit Provisional&nbsp;—
                                        "Merrill's Marauders" — in Congress during the past two
                                        years of this 116th Congressional Session.&nbsp; They have
                                        made three &nbsp;trips to Washington, DC during the past two
                                        years, the most recent in February&nbsp;2020 before Covid-19
                                        paralyzed the world. Despite pushing 100, the&nbsp;two
                                        veterans walked the halls of Congress more than three miles
                                        a day — visiting Senators and Representatives.&nbsp; They
                                        attended meetings, shook hands, handed out business cards
                                        and Merrill' Marauder literature, gave interviews and
                                        stopped to pose for photos with the hundreds of people who
                                        wanted to take away a "piece of them."
                                    </p>
                                    <p style="font-weight:400">
                                        Passanisi and Howland well represented the almost 3,000
                                        "expendable" volunteers they fought alongside in Burma by
                                        doing what they did in 1944. They put "one foot in front of
                                        the other" and kept their tiny, two-man "column moving" down
                                        the halls of Congress to complete another "impossible
                                        mission."&nbsp; Obtaining the Congressional Gold Medal has
                                        been a long series of&nbsp;"ups and downs."
                                    </p>
                                    <p style="font-weight:400">
                                        Twenty-eight Marauders were confirmed alive in 2016 when
                                        their first Congressional Gold Medal bill was
                                        introduced.&nbsp; Fortunately, several more Marauders were
                                        identified as living since then, but many more made their
                                        "final roll call."&nbsp;&nbsp;
                                        <strong>Now only nine remain alive</strong>
                                        . The other living Marauders during the long CGM journey
                                        have "cheered on" Passanisi and Howland, and done everything
                                        their aging bodies would allow — including doing media
                                        interviews by phone or in person plus contacting their U.S.
                                        Senators and Representatives for support..
                                    </p>
                                    <p style="font-weight:400">
                                        Congressman Peter King from New York, who introduced the
                                        first Marauder Congressional Gold Medal bill in the House of
                                        Representatives in 2016 during the 114th Congressional
                                        Session and again in the two subsequent, two-year sessions,
                                        retires after the 116th Congressional Session ends in 2020.
                                    </p>
                                    <p style="font-weight:400">
                                        Former Senator Johnny Isakson from Georgia, who
                                        introduced&nbsp;the first Marauder Congressional Gold Medal
                                        Senate bill in 2017 during the 115th Congressional Session,
                                        and again in the 116
                                        <sup>th</sup>
                                        &nbsp;session, retired at the end of 2019.
                                    </p>
                                    <p style="font-weight:400">
                                        Congressman Sanford Bishop from Georgia, who was
                                        Representative Peter King's major cosponsor through three
                                        consecutive Congressional Sessions will continue to support
                                        Merrill's Marauders in Congress.
                                    </p>
                                    <p style="font-weight:400">
                                        Georgia has a large Ranger community.&nbsp; Columbus, GA,
                                        one of several cities in Bishop's district, is adjacent to
                                        Ft. Benning, home of the 75
                                        <sup>th</sup>
                                        &nbsp;Ranger Regiment, whose crest is the Merrill's Marauder
                                        patch.&nbsp; Its Military Intelligence Building is named
                                        "Melillo Hall," in honor of Georgia's last Marauder, Vincent
                                        Melillo. The Airborne Ranger Training Brigade is located
                                        there, as well as 3
                                        <sup>rd</sup>
                                        &nbsp;Ranger Battalion.&nbsp; Thirty men from the 5307
                                        <sup>th</sup>
                                        &nbsp;CUP have been selected through the years for the
                                        annual Army Ranger Hall of Fame induction ceremony at Ft.
                                        Benning. Savannah is the home of 1
                                        <sup>st</sup>
                                        &nbsp;Ranger Battalion.&nbsp; Camp Frank D. Merrill in
                                        Dahlonega, where the mountain phase of Ranger training is
                                        taught, is named after the jungle unit's commander.
                                    </p>
                                    <p style="font-weight:400">
                                        <strong>
                                            WHERE ARE WE NOW IN THE CONGRESSIONAL GOLD MEDAL
                                            JOURNEY??
                                        </strong>
                                    </p>
                                    <p style="font-weight:400">
                                        All of us are now in the difficult period of being patient
                                        and waiting … and there is no estimate on how long that will
                                        be.
                                    </p>
                                    <p style="font-weight:400">
                                        A design for the Congressional Gold Medal must be
                                        selected.&nbsp; Then artists and engravers from the U.S.
                                        Mint will design and create the medal.&nbsp; Only one medal
                                        will be cast, and it goes to the Smithsonian. Bronze
                                        replicas will then be cast and made available for purchase
                                        at an affordable price. A ceremony honoring Merrill's
                                        Marauders will be held in Washington, DC at some date in the
                                        future..
                                    </p>
                                    <p style="font-weight:400">
                                        <strong>NO DETAILS on any of those steps&nbsp;</strong>
                                        <strong>are available at this time,&nbsp;</strong>
                                        <strong>
                                            but will be shared with you as soon as they are decided.
                                        </strong>
                                    </p>
                                    <p style="font-weight:400">
                                        As a time reference, the Marauders' 14 Japanese American
                                        interpreters, Nisei, were honored when the Military
                                        Intelligence Service was awarded a Congressional Gold Medal
                                        in October 2010.&nbsp; Their ceremony in Washington, DC was
                                        not held until more than a year later in November
                                        2011.&nbsp; Covid-19 does not help this process.
                                    </p>
                                    <p style="font-weight:400">
                                        <strong>
                                            So please be patient.&nbsp; You will be kept informed.
                                        </strong>
                                    </p>
                                    <p style="font-weight:400">
                                        Another small group with the Marauders, members of the
                                        Office of Strategic Services, were honored when the OSS,
                                        forerunner to the CIA, was awarded its Congressional Gold
                                        Medal.
                                    </p>
                                    <p style="font-weight:400">
                                        The Merrill's Marauders Congressional Gold Medal Act honors
                                        the almost 3,000 1943 "expendable" volunteers who trudged
                                        with their mules almost 1,000 miles through thick jungle and
                                        climbed the treacherous Kumon Mountains into Burma to seize
                                        their objective – the enemy-held Myitkyina airfield.&nbsp;
                                        It also honors the more than 2,000 replacements to the 5307
                                        <sup>th</sup>
                                        &nbsp;CUP flown into Burma after only around 200 ragged and
                                        emaciated Marauders still capable of combat had seized the
                                        airfield. Those replacements who fought to hold the airfield
                                        and capture the&nbsp;
                                        <strong><u>TOWN</u></strong>
                                        &nbsp;of Myitkyina up until the 5307
                                        <sup>th</sup>
                                        &nbsp;CUP deactivated Aug. 10, 1944, will also be honored by
                                        the Congressional Gold Medal.
                                    </p>
                                    <p style="font-weight:400">Jonnie Melillo Clasen</p>
                                    <p style="font-weight:400">
                                        Merrill's Marauder liaison officer
                                    </p>
                                    <p style="font-weight:400">
                                        Daughter, Merrill's Marauder &amp; Korean War veteran
                                        Vincent Melillo
                                    </p>
                                    <p style="font-weight:400">706 689-0153 H – NO TEXTS</p>
                                    <p style="text-align:left"></p>
                                </div>
                                <div dir="ltr" style="text-align:center">
                                    <h6 style="text-align:left">
                                        (Written by Jonnie Clasen, Posted 7.29.2020)
                                    </h6>
                                    <p style="text-align:center">WE DID IT!</p>
                                    <p style="text-align:center">
                                        <img
                                            loading="lazy"
                                            class="alignright size-full wp-image-1485"
                                            src="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauder.png?alt=media"
                                            alt=""
                                            width="817"
                                            height="652"
                                            srcset="
                                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauder.png?alt=media 817w,
                                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauder.png?alt=media 300w,
                                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauder.png?alt=media 768w,
                                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauder.png?alt=media 376w,
                                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauder.png?alt=media 501w,
                                                https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/marauder.png?alt=media 251w
                                            "
                                            sizes="(max-width: 817px) 100vw, 817px"
                                        />
                                    </p>

                                    <p>
                                        Next steps for passing and receiving the Congressional Gold
                                        Medal for Merrill's Marauders:
                                    </p>
                                </div>
                                <div dir="ltr"></div>
                                <div dir="ltr">
                                    <p>
                                        The&nbsp;frenzy of U.S. Representatives signing on to HR.
                                        906 today has given us the 290 cosponsors required for
                                        passage of the bill.&nbsp; The companion bill in the Senate,
                                        introduced by former Senator Johnny Isakson from Georgia,
                                        passed last December.
                                    </p>
                                    <p>
                                        This could not have happened without the continued efforts
                                        of all of you, many of whom have been with us through three
                                        Congressional sessions, beginning in 2016.&nbsp; There are
                                        so many individuals, organizations and businesses who have
                                        tirelessly worked to make this happen.&nbsp; Many of you
                                        will now have questions like — What happens next? When will
                                        the President sign the bill?&nbsp; When will the ceremony
                                        be?&nbsp; How do I get a replica medal? How much will it
                                        cost?
                                    </p>
                                    <p>
                                        Obtaining the Congressional Gold Medal for our fathers is a
                                        PROCESS – and we have just completed the most intense phase.
                                        There are steps that now have to be completed in this
                                        process before the Marauders can officially be awarded the
                                        Congressional Gold Medal. All of us will need to practice
                                        patience as we enter the next phase of this journey.&nbsp;
                                        You will be kept up-to-date in this process.
                                    </p>
                                    <p>
                                        California veterans champion and retired Colonel Nestor
                                        Aliga, who has already successfully pushed&nbsp;two
                                        Congressional Gold Medal campaigns through the House and
                                        Senate, explained today that the process "is
                                        involved."&nbsp; Nestor became the first serious Marauder
                                        champion last February when he took on the Marauder campaign
                                        as it was beginning its 75
                                        <sup>th</sup>
                                        &nbsp;anniversary observances. Nestor told us "to just go to
                                        Washington," and we did – for the first time – last May with
                                        Marauders Bob Passanisi and Gilbert Howland. That's when the
                                        "magic" started to happen. That's when we met Jason Maynard,
                                        Senator Isakson's Congressional Defense Fellow, who was
                                        relentless in his pursuit of getting senators to cosponsor
                                        Isakson's bill. That's when we met attorney Scott Stone from
                                        Illinois who was so impressed with Marauders Passanisi and
                                        Howland that he and Washington-DC based attorneys Fred Eames
                                        and Scott Segal decided to take on the Marauder campaign as
                                        a "pro bono" effort, with volunteers from their firms. Their
                                        strength coupled with your individual efforts plus those of
                                        the many Ranger, Special Forces and other military
                                        organizations, associations and businesses have brought us
                                        to where we are today.
                                    </p>
                                    <p>
                                        The paragraph below is the last in a document written today
                                        by attorney Scott Stone, in collaboration with Fred Eames
                                        and Scott Segal.&nbsp; It was emailed today to New York
                                        Congressman Peter King, who introduced H.R. 906 with Georgia
                                        Congressman Sanford Bishop major cosponsor, "for a letter
                                        that could go to House leadership urging action on the bill
                                        before the August recess."
                                    </p>
                                    <p style="text-align:center">
                                        <span style="color:navy">
                                            <strong>
                                                The remarkable story of Merrill's Marauders
                                            </strong>
                                            <strong>
                                                &nbsp;is at risk of being lost to history.
                                            </strong>
                                        </span>
                                    </p>
                                    <p style="text-align:center">
                                        <span style="color:navy">
                                            <strong>
                                                Awarding the Congressional Gold Medal&nbsp;
                                            </strong>
                                            <strong>
                                                creates a singular opportunity to tell this story
                                            </strong>
                                        </span>
                                    </p>
                                    <p style="text-align:center">
                                        <span style="color:navy">
                                            <strong>
                                                at a time when many are likely to draw strength and
                                                hope from its message.&nbsp;
                                            </strong>
                                        </span>
                                    </p>
                                    <p style="text-align:center">
                                        <span style="color:navy">
                                            <strong>
                                                These men have always put the country before
                                                themselves.
                                            </strong>
                                        </span>
                                    </p>
                                    <p style="text-align:center">
                                        <span style="color:navy">
                                            <strong>
                                                It is time we put their story before the
                                                country.&nbsp;
                                            </strong>
                                        </span>
                                    </p>
                                    <p>
                                        Today – 76 years after the Marauders completed their
                                        objective May 17, 1944, of seizing northern Burma's
                                        Myitkyina airstrip, only eight remain alive out of the
                                        almost 3,000 who volunteered in 1943.&nbsp; They and the
                                        heroic replacements to the 5307
                                        <sup>th</sup>
                                        &nbsp;Composite Unit Provisional who flew into the airfield
                                        after the Marauders seized it and served with the unit until
                                        it disbanded Aug. 10, 1944, will be honored by the
                                        Congressional Gold Medal.
                                    </p>
                                    <p>
                                        Two tiny groups serving with Merrill's Marauders, the 14
                                        Nisei or Japanese American interpreters and the Office of
                                        Strategic Services, forerunner to the CIA, have already been
                                        awarded a Congressional Gold Medal. It was after the
                                        Marauders' 14 Japanese American interpreters were awarded
                                        the Congressional Gold Medal as part of the Military
                                        Intelligence Service on Oct. 5, 2010, that the idea was born
                                        to pursue a Congressional Gold Medal for the rest of the
                                        men. A proposal to pursue efforts to make that happen was
                                        made and passed by the then-active Merrill's Marauders Proud
                                        Descendants.&nbsp; Since that time, the Marauders
                                        accomplished another massive grassroots effort in 2014,
                                        which was having governors of every state in the nation
                                        (except California, which had technical glitches) declare
                                        Aug. 10, 2014, as National WW II Merrill's Marauder Day.
                                        That's the day 70 years earlier the unit disbanded in Burma.
                                        Many of you have been involved since 2010 in getting the CGM
                                        message out, gaining support in your respective states and
                                        trying to get senators and representatives to introduce
                                        Congressional Gold Medal bills.
                                    </p>
                                    <p>
                                        Please see
                                        <a
                                            href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Marauder-2020-CGM-Nisei-crmny.pdf?alt=media"
                                        >
                                            this link
                                        </a>
                                        with photos of three of the Marauder Nisei who were honored
                                        at the MIS Congressional Gold Medal ceremony Nov. 2, 2011,
                                        one year after they were awarded the Congressional Gold
                                        Medal. The attachment was part of an email newsletter I did
                                        at that time for the National Ranger Memorial Foundation.
                                    </p>
                                    <p style="text-align:center">
                                        <span style="color:green">
                                            <strong>"The third time is a charm!!"</strong>
                                        </span>
                                    </p>
                                    <p style="text-align:center">
                                        <span style="color:green">
                                            <strong>
                                                Thanks for "not giving up" on this mission all these
                                                years!!!
                                            </strong>
                                        </span>
                                    </p>
                                    <p>&nbsp;</p>
                                    <p>
                                        Jonnie Melillo Clasen
                                        <br />
                                        Merrill's Marauder liaison officer
                                        <br />
                                        Daughter, Merrill's Marauder &amp; Korean War veteran
                                        Vincent Melillo
                                        <br />
                                        706 689-0153 H NO TEXTS
                                        <br />
                                        828 230-8724 C NO TEXTS
                                    </p>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </template>
    </Article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'CongressionalGoldMedal',
    components: { Article }
});
</script>
